export interface NotificationConfig {
  autoClose: boolean;
  autoCloseDelay: number;
  showToaster: boolean;
  playSound: boolean;
  requireInteraction: boolean;
  showBrowserNotification: boolean;
}

export interface NotificationSoundConfig {
  [key: string]: string;
}

export const DEFAULT_NOTIFICATION_CONFIG: NotificationConfig = {
  autoClose: true,
  autoCloseDelay: 8000, // 8 seconds
  showToaster: true,
  playSound: true,
  requireInteraction: true,
  showBrowserNotification: true
};

export const NOTIFICATION_SOUNDS: NotificationSoundConfig = {
  'default': 'notification-default.mp3',
  'booking': 'notification-booking.mp3',
  'trip': 'notification-trip.mp3',
  'payment': 'notification-payment.mp3',
  'message': 'notification-message.mp3'
};

export const NOTIFICATION_TYPES = {
  BOOKING: 'booking',
  TRIP: 'trip',
  PAYMENT: 'payment',
  MESSAGE: 'message',
  GENERAL: 'general'
} as const;

export type NotificationType = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];

export interface NotificationRoute {
  [key: string]: string;
}

export const NOTIFICATION_ROUTES: NotificationRoute = {
  [NOTIFICATION_TYPES.BOOKING]: '/after-login/vehicle-booking',
  [NOTIFICATION_TYPES.TRIP]: '/after-login/trip-details',
  [NOTIFICATION_TYPES.PAYMENT]: '/after-login/wallet',
  [NOTIFICATION_TYPES.MESSAGE]: '/after-login/notifications',
  [NOTIFICATION_TYPES.GENERAL]: '/after-login'
};
